import React from 'react';
import styled from 'styled-components';
import { Nav } from '@catalogo/core-nav';
import { getIn } from 'seamless-immutable';

export const AirConditionerInfo = ({ product }) => {
  const isAirConditioner = getIn(product, ['isAirConditioner'], false);

  if (!isAirConditioner) {
    return null;
  }

  return (
    <Wrapper>
      <Text strong>Já sabe qual ar condicionado comprar?</Text>
      <Text>Descubra qual é o ideal para deixar seu ambiente geladinho!</Text>
      <NavUI>
        <Nav to="#modal-air-conditioner-info">ver dica</Nav>
      </NavUI>
    </Wrapper>
  );
};

const Text = styled.p`
  ${({ strong }) => strong && `font-weight: bold;`}
  font-size: 15px;
`;

const NavUI = styled.p`
  text-decoration: underline;
  font-size: 14px;
  margin: 15px 0 30px;
`;

const Wrapper = styled.div`
  border-bottom: 1px solid rgb(206, 204, 204, 0.4);
  margin: 30px 0;
`;

export default AirConditionerInfo;
